import React from "react";
import Text from "../atoms/Text";
import products from "../../data/products.json";
import { formatCurrency } from "./ProfileShared";

export default function OrderDetailsProfile({ selectedOrder, onBackToOrders }) {
  const items = (selectedOrder?.items || []).map((item) => {
    const product = products.find((entry) => entry.id === item.productId);

    return {
      ...item,
      product,
      subtotal: (product?.price || 0) * item.quantity,
    };
  });

  const statusSteps = ["Order received", "Processing", "On the way", "Delivered"];
  const statusToStepMap = {
    "order received": 0,
    processing: 1,
    "on the way": 2,
    completed: 3,
    delivered: 3,
  };
  const normalizedStatus = selectedOrder?.status?.toLowerCase() || "";
  const activeStepIndex = statusToStepMap[normalizedStatus] ?? 0;

  return (
    <div
      className="order-details-profile"
      style={{
        border: "1px solid var(--gray1)",
        borderRadius: "8px",
        backgroundColor: "var(--white)",
        overflow: "hidden",
      }}
    >
      <div
        className="order-details-top"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 24px",
          borderBottom: "1px solid var(--gray1)",
        }}
      >
        <Text size="px20" weight="w500" color="gray9">
          Order Details
          <span style={{ color: "var(--gray5)", fontSize: "14px", fontWeight: 400 }}>
            {" "}
            • {selectedOrder?.date} • {selectedOrder?.items?.length || 0} Products
          </span>
        </Text>
        <button
          type="button"
          onClick={onBackToOrders}
          style={{
            border: "none",
            backgroundColor: "transparent",
            color: "var(--primary)",
            fontSize: "14px",
            fontWeight: 500,
            cursor: "pointer",
            fontFamily: "inherit",
            padding: 0,
          }}
        >
          Back to List
        </button>
      </div>

      <div
        style={{
          padding: "24px",
          display: "grid",
          gridTemplateColumns: "1.15fr 1.15fr 0.95fr",
          gap: "16px",
        }}
      >
        {[selectedOrder?.billingAddress, selectedOrder?.shippingAddress].map((address, index) => (
          <div
            key={index}
            style={{
              border: "1px solid var(--gray1)",
              borderRadius: "4px",
              padding: "18px",
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Text size="px12" weight="w500" color="gray4" extraStyles={{ textTransform: "uppercase" }}>
              {index === 0 ? "Billing Address" : "Shipping Address"}
            </Text>
            <Text size="px16" weight="w500" color="gray9">
              {address?.name}
            </Text>
            <Text size="px14" weight="w400" color="gray5">
              {address?.address}
            </Text>
            <Text
              size="px12"
              weight="w500"
              color="gray4"
              extraStyles={{ marginTop: "8px", textTransform: "uppercase" }}
            >
              Email
            </Text>
            <Text size="px14" weight="w400" color="gray9">
              {address?.email}
            </Text>
            <Text size="px12" weight="w500" color="gray4" extraStyles={{ textTransform: "uppercase" }}>
              Phone
            </Text>
            <Text size="px14" weight="w400" color="gray9">
              {address?.phone}
            </Text>
          </div>
        ))}

        <div
          style={{
            border: "1px solid var(--gray1)",
            borderRadius: "4px",
            padding: "18px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Text
              size="px12"
              weight="w400"
              color="gray5"
              extraStyles={{ textTransform: "uppercase" }}
            >
              Order ID:
            </Text>
            <Text size="px14" weight="w400" color="gray9">
              {selectedOrder?.id}
            </Text>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Text size="px14" weight="w400" color="gray5" extraStyles={{ textTransform: "none" }}>
              Payment:
            </Text>
            <Text size="px14" weight="w400" color="gray9">
              {selectedOrder?.paymentMethod}
            </Text>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Text size="px14" weight="w400" color="gray5">
              Subtotal:
            </Text>
            <Text size="px14" weight="w500" color="gray9">
              {formatCurrency(selectedOrder?.total)}
            </Text>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Text size="px14" weight="w400" color="gray5">
              Discount:
            </Text>
            <Text size="px14" weight="w500" color="gray9">
              {Math.round((selectedOrder?.discountRate || 0) * 100)}%
            </Text>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Text size="px14" weight="w400" color="gray5">
              Shipping:
            </Text>
            <Text size="px14" weight="w500" color="gray9">
              Free
            </Text>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "12px",
              borderTop: "1px solid var(--gray1)",
            }}
          >
            <Text size="px18" weight="w500" color="gray9">
              Total
            </Text>
            <Text size="px24" weight="w600" color="primary">
              {formatCurrency(selectedOrder?.total)}
            </Text>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 24px 24px" }}>
        <div
          style={{
            border: "1px solid var(--gray1)",
            borderRadius: "6px",
            padding: "18px 20px",
            marginBottom: "24px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Text
            size="px16"
            weight="w500"
            color="gray9"
            extraStyles={{ display: "block", textAlign: "start" }}
          >
            Additional Info
          </Text>
          <Text
            size="px14"
            weight="w400"
            color="gray5"
            extraStyles={{
              display: "block",
              textAlign: "start",
              lineHeight: "150%",
            }}
          >
            {selectedOrder?.orderNotes?.trim() || "None"}
          </Text>
        </div>

        <div
          className="order-details-progress"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "12px",
            alignItems: "center",
            marginBottom: "24px",
          }}
        >
          {statusSteps.map((step, index) => {
            const isCompleted = index <= activeStepIndex;

            return (
              <div
                key={step}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "8px",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "32px",
                    height: "32px",
                    borderRadius: "50%",
                    border: isCompleted ? "none" : "1px dashed var(--primary)",
                    backgroundColor: isCompleted ? "var(--primary)" : "var(--white)",
                    color: isCompleted ? "var(--white)" : "var(--primary)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "14px",
                    fontWeight: 600,
                    zIndex: 1,
                  }}
                >
                  {index + 1}
                </div>
                <Text size="px14" weight="w400" color="gray6">
                  {step}
                </Text>
                {index < statusSteps.length - 1 ? (
                  <span
                    style={{
                      position: "absolute",
                      top: "15px",
                      right: "-50%",
                      width: "100%",
                      height: "4px",
                      backgroundColor: index < activeStepIndex ? "var(--primary)" : "var(--gray1)",
                    }}
                  />
                ) : null}
              </div>
            );
          })}
        </div>

        <div
          className="order-details-products-head"
          style={{
            display: "grid",
            gridTemplateColumns: "1.7fr 1fr 1fr 1fr",
            padding: "12px 24px",
            backgroundColor: "var(--gray05)",
          }}
        >
          {["Product", "Price", "Quantity", "Subtotal"].map((heading) => (
            <Text
              key={heading}
              size="px12"
              weight="w500"
              color="gray5"
              extraStyles={{ textTransform: "uppercase", textAlign: "start" }}
            >
              {heading}
            </Text>
          ))}
        </div>

        {items.map((item) => (
          <div
            className="order-details-products-row"
            key={`${selectedOrder?.id}-${item.productId}`}
            style={{
              display: "grid",
              gridTemplateColumns: "1.7fr 1fr 1fr 1fr",
              padding: "18px 24px",
              borderTop: "1px solid var(--gray05)",
              alignItems: "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <img
                src={item.product?.image}
                alt={item.product?.name}
                style={{ width: "60px", height: "60px", objectFit: "contain" }}
              />
              <Text size="px14" weight="w400" color="gray9">
                {item.product?.name}
              </Text>
            </div>
            <Text size="px14" weight="w400" color="gray9">
              {formatCurrency(item.product?.price)}
            </Text>
            <Text size="px14" weight="w400" color="gray9">
              x{item.quantity}
            </Text>
            <Text size="px14" weight="w500" color="gray9">
              {formatCurrency(item.subtotal)}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
}
